var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          selection: _vm.selection,
          "label-width": "80px",
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "search-btn-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _vm.queryParamsTradeStatus == "0"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.companySeller"),
                              prop: "clientCode",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.clientCodeList,
                                placeholder: _vm.$t(
                                  "billingPage.companySeller"
                                ),
                              },
                              on: { change: _vm.handleQuery },
                              model: {
                                value: _vm.queryParams.clientCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "clientCode", $$v)
                                },
                                expression: "queryParams.clientCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.queryParamsTradeStatus == "0"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CATime"),
                              prop: "updateTime",
                            },
                          },
                          [
                            _c("BjDateRangePicker", {
                              attrs: {
                                placeholder: _vm.$t("billingPage.CATime"),
                              },
                              on: { change: _vm.handleQuery },
                              model: {
                                value: _vm.queryParamsUpdateTime,
                                callback: function ($$v) {
                                  _vm.queryParamsUpdateTime = $$v
                                },
                                expression: "queryParamsUpdateTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.queryParamsTradeStatus == "0"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CAaccountF"),
                              prop: "balanceFrom",
                            },
                          },
                          [
                            _c("BjInputNumber", {
                              staticClass: "full-width",
                              attrs: {
                                placeholder: _vm.$t("billingPage.CAaccountF"),
                                clearable: "",
                                controls: false,
                              },
                              model: {
                                value: _vm.queryParams.balanceFrom,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "balanceFrom", $$v)
                                },
                                expression: "queryParams.balanceFrom",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.queryParamsTradeStatus == "0"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CAaccountT"),
                              prop: "balanceTo",
                            },
                          },
                          [
                            _c("BjInputNumber", {
                              staticClass: "full-width",
                              attrs: {
                                placeholder: _vm.$t("billingPage.CAaccountT"),
                                clearable: "",
                                controls: false,
                              },
                              model: {
                                value: _vm.queryParams.balanceTo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "balanceTo", $$v)
                                },
                                expression: "queryParams.balanceTo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.queryParamsTradeStatus == "0"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan / 2 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.totalBalance1"),
                              prop: "totalBalance",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                style:
                                  _vm.totalBalance < 0
                                    ? "color:red;font-weight: bold;"
                                    : "color:#082dc3;font-weight: bold;",
                              },
                              [_vm._v(_vm._s(_vm.totalBalance))]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.queryParamsTradeStatus == "0"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan / 2 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.totalAvailable1"),
                              prop: "totalAvailable",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                style:
                                  _vm.totalAvailable < 0
                                    ? "color:red;font-weight: bold;"
                                    : "color:#082dc3;font-weight: bold;",
                              },
                              [_vm._v(_vm._s(_vm.totalAvailable))]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.queryParamsTradeStatus == "0"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan / 2 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.totalCredit1"),
                              prop: "totalCredit",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                style:
                                  _vm.totalCredit < 0
                                    ? "color:red;font-weight: bold;"
                                    : "color:#082dc3;font-weight: bold;",
                              },
                              [_vm._v(_vm._s(_vm.totalCredit))]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.queryParamsTradeStatus == "0"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan / 2 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.totalUnpaid1"),
                              prop: "totalUnpaid",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                style:
                                  _vm.totalUnpaid < 0
                                    ? "color:red;font-weight: bold;"
                                    : "color:#082dc3;font-weight: bold;",
                              },
                              [_vm._v(_vm._s(_vm.totalUnpaid))]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.queryParamsTradeStatus == "1"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.companySeller"),
                              prop: "clientCodes",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                multiple: "",
                                "option-list": _vm.clientCodeList,
                                placeholder: _vm.$t(
                                  "billingPage.companySeller"
                                ),
                              },
                              on: { change: _vm.handleQuery },
                              model: {
                                value: _vm.queryParams.clientCodes,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "clientCodes", $$v)
                                },
                                expression: "queryParams.clientCodes",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.queryParamsTradeStatus == "1"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.source"),
                              prop: "source",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.sourceList,
                                placeholder: _vm.$t("billingPage.source"),
                              },
                              on: { change: _vm.handleQuery },
                              model: {
                                value: _vm.queryParams.source,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "source", $$v)
                                },
                                expression: "queryParams.source",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.queryParamsTradeStatus == "1"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.gmtCreate"),
                              prop: "updateTime",
                            },
                          },
                          [
                            _c("BjDateRangePicker", {
                              attrs: {
                                placeholder: _vm.$t("billingPage.gmtCreate"),
                              },
                              on: { change: _vm.handleQuery },
                              model: {
                                value: _vm.queryParamsTransTime,
                                callback: function ($$v) {
                                  _vm.queryParamsTransTime = $$v
                                },
                                expression: "queryParamsTransTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "beforeSearchBtn",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: 24 - _vm.colSpan } },
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: {
                          value: _vm.queryParamsTradeStatus,
                          type: "card",
                        },
                        on: { "tab-click": _vm.handleTabClick },
                      },
                      _vm._l(
                        _vm.CSG_CLIENTACCOUNTS_TAB_LIST,
                        function (item, index) {
                          return _c("el-tab-pane", {
                            key: index,
                            attrs: {
                              label: _vm.$t(item.label),
                              name: item.value,
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _vm.queryParamsTradeStatus == "0"
                      ? _c("BjFrontendExport", {
                          staticClass: "main-btn",
                          attrs: {
                            type: "primary",
                            "label-list": _vm.labelList,
                            rows: _vm.selectedRows,
                            "file-name": "Wallet Balance.csv",
                          },
                        })
                      : _vm._e(),
                    _vm.queryParamsTradeStatus == "1"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onExport2 },
                          },
                          [_vm._v(_vm._s(_vm.$t("exportText")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "balance"
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.balance) +
                                              " "
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }